// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-container {
  width: 800px;
  height: 650px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding: 0 43px;
  animation: fadeIn 1s;
}
.confirm-container .header, .confirm-container .subheader {
  font-family: "Proxima Nova", sans-serif;
  margin: 0;
}
.confirm-container .header {
  font-size: 40px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.confirm-container .subheader {
  font-size: 25px;
  font-weight: 600;
  color: var(--secondary-color-2);
  text-align: center;
}
.confirm-container .browse {
  width: 240px;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .confirm-container {
    width: 100%;
    height: auto;
    margin: 0 20px;
    padding: 40px;
    text-align: center;
  }
  .confirm-container .header {
    font-size: 32px;
  }
  .confirm-container .subheader {
    font-size: 18px;
  }
  .confirm-container .browse {
    height: 40px;
    font-size: 16px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .confirm-container {
    width: 100%;
    height: auto;
    margin: 0 20px;
    padding: 40px;
    text-align: center;
  }
  .confirm-container .header {
    font-size: 32px;
  }
  .confirm-container .subheader {
    font-size: 18px;
  }
  .confirm-container .browse {
    height: 40px;
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Response/modules/ConfirmFeedback/confirm.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AADJ;AAEI;EACI,uCAAA;EACA,SAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;AAAR;AAEI;EACI,YAAA;AAAR;AAEI;EACI;IAAK,UAAA;EACX;EAAM;IAAO,UAAA;EAGb;AACF;;ACjCY;EDkCR;IACI,WAAA;IACA,YAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;EAGN;EAFM;IACI,eAAA;EAIV;EAFM;IACI,eAAA;EAIV;EAFM;IACI,YAAA;IACA,eAAA;EAIV;AACF;AC9CY;ED2BR;IACI,WAAA;IACA,YAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;EAsBN;EArBM;IACI,eAAA;EAuBV;EArBM;IACI,eAAA;EAuBV;EArBM;IACI,YAAA;IACA,eAAA;EAuBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.confirm-container {\r\n    width: 800px;\r\n    height: 650px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-self: center;\r\n    padding: 0 43px;\r\n    animation: fadeIn 1s;\r\n    .header, .subheader {\r\n        font-family: 'Proxima Nova', sans-serif;\r\n        margin: 0;\r\n    }\r\n    .header {\r\n        font-size: 40px;\r\n        font-weight: 700;\r\n        color: var(--secondary-color-1);\r\n    }\r\n    .subheader {\r\n        font-size: 25px;\r\n        font-weight: 600;\r\n        color: var(--secondary-color-2);\r\n        text-align: center;\r\n    }\r\n    .browse {\r\n        width: 240px;\r\n    }\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n@include media(mobile, tablet) {\r\n    .confirm-container {\r\n        width: 100%;\r\n        height: auto;\r\n        margin: 0 20px;\r\n        padding: 40px;\r\n        text-align: center;\r\n        .header {\r\n            font-size: 32px;\r\n        }\r\n        .subheader {\r\n            font-size: 18px;\r\n        }\r\n        .browse {\r\n            height: 40px;\r\n            font-size: 16px;\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
